// extracted by mini-css-extract-plugin
export var closeTooltip = "feedbackContainer-module--closeTooltip--pkTeo";
export var feedbackButton = "feedbackContainer-module--feedbackButton--WCnnD";
export var tooltipContent = "feedbackContainer-module--tooltipContent--8qxPm";
export var tooltipHeading = "feedbackContainer-module--tooltipHeading--wlWpw";
export var tooltipMessage = "feedbackContainer-module--tooltipMessage--y4nbW";